import request from '@/utils/request'

// 代扣信息确认接口
export function getWalletUserNotificationMessagePage(data) {
  return request({
    url: '/walletUserNotificationMessage/getWalletUserNotificationMessagePage',
    method: 'post',
    data
  })
}

// 用户取消授权接口
export function UnAuth(data) {
  return request({
    url: '/walletUserDirectDebitAuth/unAuth',
    method: 'post',
    data
  })
}

// 授权详情查询接口
export function AuthDetail(data) {
  return request({
    url: '/walletUserDirectDebitAuth/auth/detail',
    method: 'post',
    data
  })
}

// 分页查询钱包用户已授权记录
export function AuthList(data) {
  return request({
    url: '/walletUserDirectDebitAuth/auth/list',
    method: 'post',
    data
  })
}

// 输入 OTP 开通授权代扣接口
export function Auth(data) {
  return request({
    url: '/walletUserDirectDebitAuth/auth',
    method: 'post',
    data
  })
}

// 发送开通代扣授权验证码
export function SendOpt(params) {
  return request({
    url: '/walletUserDirectDebitAuth/sendOpt',
    method: 'get',
    params
  })
}
